import { getLocationAddress } from "../../utils/formatters";

function AvailabilityBadge({ available, label }) {
  return (
    <span className={available ? "badge badge-success" : "badge badge-muted"}>
      {available ? label : `No ${label.toLowerCase()}`}
    </span>
  );
}

function LocationCard({ location, onSelect }) {
  return (
    <article className="location-card public-location-card">
      <div className="card-body">
        <p className="eyebrow">Location</p>
        <h3>{location.name}</h3>
        <p className="muted-text">{getLocationAddress(location)}</p>

        {location.phone ? (
          <a href={`tel:${location.phone}`} className="public-card-link">
            {location.phone}
          </a>
        ) : null}

        <div className="public-badge-list" aria-label="Services available">
          <AvailabilityBadge available={location.accepts_pickup} label="Pickup" />
          <AvailabilityBadge available={location.accepts_delivery} label="Delivery" />
          <AvailabilityBadge available={location.accepts_catering} label="Catering" />
        </div>

        <button className="btn btn-primary btn-block" type="button" onClick={() => onSelect(location)}>
          View This Menu
        </button>
      </div>
    </article>
  );
}

export default LocationCard;